import { render, staticRenderFns } from "./OtherBanner.vue?vue&type=template&id=06dca51e&scoped=true&"
import script from "./OtherBanner.vue?vue&type=script&lang=js&"
export * from "./OtherBanner.vue?vue&type=script&lang=js&"
import style0 from "./OtherBanner.vue?vue&type=style&index=0&id=06dca51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dca51e",
  null
  
)

export default component.exports